"use client";

import { DisclosurePolicy } from "../sections/DisclosurePolicy";
import { Shell } from "./Shell";

/**
 * `/disclosure` beneath the client boundary (`WEB-044`).
 *
 * The route file above it stays a server component so it can export `metadata`; this is where
 * the boundary sits, because the document and the chrome both use hooks. Prerendering is
 * unaffected — Next renders client components to HTML at build time, which is the property
 * `D-020` is buying.
 */
export function DisclosureView() {
  return (
    <Shell honorableMentions>
      <DisclosurePolicy />
    </Shell>
  );
}
